import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import {
	QueryCache,
	QueryClient,
	QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import axios from 'axios';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { handleUnauthorizedResponse } from '../api/http';
import { AuthProvider, useAuthContext } from '../context/auth';
import {
	SESSION_EXPIRED_BUTTON,
	SESSION_EXPIRED_MESSAGE,
	SESSION_EXPIRED_TITLE,
} from '../data/constants';
import theme from '../util/theme';
import NamespaceApp from './NamespaceApp';
import TenantApp from './TenantApp';

const Main = () => {
	const authData = useAuthContext();
	const [queryClient] = React.useState(
		() =>
			new QueryClient({
				queryCache: new QueryCache({
					onError: (error) => {
						axios.isAxiosError(error) &&
							handleUnauthorizedResponse(error, authData);
					},
				}),
			}),
	);

	return (
		<QueryClientProvider client={queryClient}>
			{authData.ssoConfig.ssoEnabled &&
			authData.ssoConfig.ssoVersion === 'v1' ? (
				<NamespaceApp />
			) : (
				<TenantApp />
			)}
			<ReactQueryDevtools initialIsOpen={false} />
			<Dialog open={authData.isLoggedOut}>
				<DialogTitle>{SESSION_EXPIRED_TITLE()}</DialogTitle>
				<DialogContent>
					<DialogContentText>{SESSION_EXPIRED_MESSAGE()}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button color='secondary' onClick={authData.logout}>
						{SESSION_EXPIRED_BUTTON()}
					</Button>
				</DialogActions>
			</Dialog>
		</QueryClientProvider>
	);
};

export const App = () => {
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<AuthProvider>
					<ToastContainer />
					<Main />
				</AuthProvider>
			</ThemeProvider>
		</StyledEngineProvider>
	);
};
